<!-- 
    Wrapper for Buefy Dropdown 
-->
<template>
    <div class="b-wrap">
        <b-dropdown 
            ref="dropdown"
            :position="computedPosition"
            v-bind="$props"
        >
            <template #trigger>
                <slot name="trigger"></slot>
            </template>

            <!-- Default slot for <b-dropdown-item> list -->
            <slot></slot>
        </b-dropdown>
    </div>
</template>

<script>
import { mixVModel } from '@/vue/mixins/vmodel.mix';
import {useLayoutElements} from "@/vue/store/useLayoutElements";
const {getPageFooter} = useLayoutElements()

export default {
    mixins:[mixVModel],
    props: {
        /* 
            Buefy props
            Some props are commented out intentionally
            as they are not in use.
        */
        value: {
            type: [
                String,
                Number,
                Boolean,
                Object,
                Array,
                Function
            ],
            default: null
        },
        disabled: Boolean,
        // inline: Boolean,
        scrollable: Boolean,
        maxHeight: {
            type: [String, Number],
            default: 200
        },

        /* 
            See computedPosition
            position: {
                type: String,
                validator(value) {
                    return [
                        'is-top-right',
                        'is-top-left',
                        'is-bottom-left',
                        'is-bottom-right'
                    ].indexOf(value) > -1
                }
            },
        */

        triggers: {
            type: Array,
            default: () => ['click']
        },
        // mobileModal: {
        //     type: Boolean,
        //     default: () => {
        //         return config.defaultDropdownMobileModal
        //     }
        // },
        ariaRole: {
            type: String,
            validator(value) {
                return [
                    'menu',
                    'list',
                    'dialog'
                ].indexOf(value) > -1;
            },
            default: 'menu' // changed default to "menu"
        },
        // animation: {
        //     type: String,
        //     default: 'fade'
        // },
        // multiple: Boolean,
        trapFocus: {
            type: Boolean,
            default: true // changed to true
        },
        closeOnClick: {
            type: Boolean,
            default: true
        },
        canClose: {
            type: [Array, Boolean],
            default: true
        },

        /* 
            These require a newer version of Buefy
            expanded: Boolean,
            appendToBody: Boolean,
            appendToBodyCopyParent: Boolean
        */

    },
    data(){
        return {
            triggerOffset: 0,
            footerOffset: 0,
        };
    },
    computed:{
        spaceBelow(){
            return this.footerOffset - this.triggerOffset;
        },
        computedPosition(){
            const BUFFER_HEIGHT = 20; 

            // const dropdownOffset = $(getPageFooter).offset().top
            // should show on top
            if (this.spaceBelow < this.maxHeight + BUFFER_HEIGHT) {
                return 'is-top-right';
            }
            return 'is-bottom-right';
        }
    },

    mounted(){
        const vm = this;

        $(window).on('load', () => {
            const $trigger = $(vm.$refs.dropdown.$refs.trigger);
            vm.setOffsets($trigger);

            // update triggerOffset on resize
            $(window).on('resize', () => {
                // update trigger offset
                vm.setOffsets($trigger);
            });
        });

    },
    updated(){
        this.setOffsets($(this.$refs.dropdown.$refs.trigger));
    },
    methods: {
        setOffsets($trigger){
            this.triggerOffset = $trigger.offset().top + $trigger.height();
            this.footerOffset = getPageFooter().offsetTop || 0;
        }
    }

};
</script>
